import React__default from 'react';
import { Image } from '@deal/components';
import { useApplicationContext, Application } from '../../../../../containers/ApplicationContext/index.js';
import { SharedRichCardEvents } from '../../../../../containers/RichCardEventEmitter/SharedEventData/index.js';
import { useRichCardEventEmitter } from '../../../../../containers/RichCardEventEmitter/index.js';
import styles from './styles.css.js';

var SellableWithTitle = function SellableWithTitle(_a) {
  var sellable = _a.sellable;
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;
  return React__default.createElement("div", {
    className: styles.clickableTitle,
    onClick: function onClick() {
      if (application === Application.CONSUMER || application === Application.BUSINESS) {
        richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
          type: SharedRichCardEvents.VIEW_SELLABLE,
          id: sellable.id,
          slug: sellable.slug,
          friendlyId: sellable.friendlyId,
          sellableType: sellable.type,
          url: sellable.consumerUrl
        });
      }
    }
  }, React__default.createElement("div", {
    className: styles.sellableRow
  }, sellable.images[0] && React__default.createElement("div", {
    className: styles.sellableImage
  }, React__default.createElement(Image, {
    src: sellable.images[0].url,
    width: 32,
    className: styles.sellableIconImage
  })), React__default.createElement("div", {
    className: styles.sellableTitle
  }, sellable.title)));
};

export default SellableWithTitle;
//# sourceMappingURL=index.js.map
